import intl from 'react-intl-universal';
import { IssueState } from 'shared/constants/issues';
import State from 'components/DataTable/State';
import Deadline from 'components/DataTable/Deadline';
import { formatTime } from 'utils/formatTime';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import logger from 'utils/logger';
//! Due to the fact that the intl needs to be initialized with a arrow function, we need to change the functions
//! https://github.com/alibaba/react-intl-universal/issues/144#issuecomment-1345193138

const log = logger.createLogger('HistoryCommonColumns');

export const caseTitleColumn = () => ({
  accessorKey: 'case_title',
  header: intl.get('case_list_label_column_case_title'),
  enableSorting: false,
  filterVariant: 'textField',
  filterFn: 'fuzzy',
  enableFacetedValues: false,
});

export const stateColumn = () => ({
  accessorKey: 'state',
  header: intl.get('case_list_label_column_state'),
  filterVariant: 'multi-select',
  enableFacetedValues: false,
  Cell: stateCell,
  filterSelectOptions: [
    {
      label: intl.get('shared_value_state_normal'),
      value: IssueState.NORMAL,
    },
    {
      label: intl.get('shared_value_state_warning'),
      value: IssueState.WARNING,
    },
    {
      label: intl.get('shared_value_state_error'),
      value: IssueState.ERROR,
    },
  ],
});

const stateCell = ({ renderedCellValue }) => {
  return <State state={renderedCellValue} />;
};

stateCell.propTypes = {
  renderedCellValue: PropTypes.string.isRequired,
};

export const deadlineColumn = () => ({
  accessorKey: 'deadline',
  header: intl.get('case_list_label_column_deadline'),
  enableColumnFilter: false,
  enableFacetedValues: false,
  enableSorting: true,
  Cell: deadlineCell,
  sortingFn: (rowA, rowB, columnId) => {
    const deadline1 = new Date(rowA.getValue(columnId));
    const deadline2 = new Date(rowB.getValue(columnId));
    return deadline1 < deadline2 ? -1 : deadline1 > deadline2 ? 1 : 0;
  },
});

const deadlineCell = ({ row, _ }) => {
  // Use row.getValue to get the actual deadline value instead of relying on renderedCellValue
  const deadlineValue = row.getValue('deadline');
  const currentStatus = row.original.status;
  return <Deadline deadline={deadlineValue} currentStatus={currentStatus} />;
};

deadlineCell.propTypes = {
  row: PropTypes.object.isRequired,
  renderedCellValue: PropTypes.string.isRequired,
};

export const orderTimeColumn = () => ({
  accessorKey: 'order_time',
  header: intl.get('case_list_label_column_order_time'),
  enableColumnFilter: false,
  enableFacetedValues: false,
  Cell: ({ row }) => {
    const orderTimeValue = row.getValue('order_time');
    return formatTime(orderTimeValue);
  },
});

export const returnedTimeColumn = () => ({
  accessorKey: 'returned_time',
  header: intl.get('case_list_label_column_returned_time'),
  enableColumnFilter: false,
  enableFacetedValues: false,
  Cell: ({ row }) => {
    const returnedTimeValue = row.getValue('returned_time');
    if (!returnedTimeValue) {
      return '-';
    }
    return formatTime(returnedTimeValue);
  },
});

export const viewColumn = (handleOpenIssueDetails) => ({
  accessorKey: 'view',
  header: intl.get('case_list_label_column_details'),
  enableFacetedValues: false,
  enableColumnFilter: false,
  enableColumnActions: false,
  enableSorting: false,
  muiTableBodyCellProps: {
    onClick: (e) => e.stopPropagation(),
  },
  Cell: ({ renderedCellValue }) =>
    viewCell({ renderedCellValue, handleOpenIssueDetails }),
});

const viewCell = ({ renderedCellValue, handleOpenIssueDetails }) => {
  const issueId = renderedCellValue;
  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          handleOpenIssueDetails(issueId);
        }}>
        {intl.get('case_list_button_view')}
      </Button>
    </div>
  );
};

viewCell.propTypes = {
  renderedCellValue: PropTypes.string.isRequired,
  handleOpenIssueDetails: PropTypes.func.isRequired,
};
